window.dataLayer = window.dataLayer || [];

import {
  clickHandler,
  determineActionText,
  queryURL,
} from '@/ui/scripts/analytics/analytics.methods';

const eventDetailName = 'eventDetail_tracking';
const eventDetailActionPropTitle = 'eventDetail_action';
const eventDetailLabelPropTitle = 'eventDetail_label';

const eventDetailComp = document.querySelector('.js-event-detail-ga');
const eventTitle = eventDetailComp?.querySelector('.js-event-title-ga')?.textContent.trim();
const addToCalendarCta = eventDetailComp?.querySelector('.js-add-to-calendar-ga');
const signUpCta = eventDetailComp?.querySelector('.js-sign-up-ga');
const sidebarLinks = eventDetailComp?.querySelectorAll('.js-event-detail-list-ga a');

function getCtaPrefix(cta) {
  return cta === addToCalendarCta ? 'addEventToCalendar' : 'signUpToEvent';
}

function bindEventListener(el) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: `${getCtaPrefix(el)}_tracking`,
      actionProp: `${getCtaPrefix(el)}_action`,
      labelProp: `${getCtaPrefix(el)}_label`,
      action: `Click - ${determineActionText(el)}`,
      label: eventTitle,
    }),
  );
}

function bindEventDetailListener(el) {
  el.addEventListener(
    'click',
    clickHandler.bind(this, {
      event: eventDetailName,
      actionProp: eventDetailActionPropTitle,
      labelProp: eventDetailLabelPropTitle,
      action: `Click - ${determineActionText(el)} - ${eventTitle}`,
      label: queryURL(el),
    }),
  );
}

function init() {
  if (!eventDetailComp) {
    return;
  }

  if (sidebarLinks.length) {
    sidebarLinks.forEach((link) => {
      bindEventDetailListener(link);
    });
  }

  if (addToCalendarCta) {
    bindEventListener(addToCalendarCta);
  }

  if (signUpCta) {
    bindEventListener(signUpCta);
  }
}

export default init;
